/* eslint-disable space-before-function-paren */
/* eslint-disable no-duplicate-imports */
import * as Yup from 'yup'
import { BaseSchema } from 'yup'
declare module 'yup' {
  interface StringSchema<TType, TContext, TOut> extends BaseSchema<TType, TContext, TOut> {
    rutValidation(rut: string): this
    onlyDigits(value: string): this
  }
}


Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'rutValidation',
  function (errorMessage) {
    return this.test(`rutValidation`, errorMessage, function (value) {
      const { path, createError } = this

      if (!value) return createError({ path, message: errorMessage })

      const Validate = {
        validaRut(value: string) {
          if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(value)) return false

          const tmp = value.split('-')
          let digv = tmp[1]
          const rut = tmp[0]

          if (digv === 'K') digv = 'k'

          return Validate.dv(parseInt(rut)) === digv
        },
        dv(rut: number) {
          let M = 0,
            S = 1

          for (; rut; rut = Math.floor(rut / 10))
            S = (S + (rut % 10) * (9 - (M++ % 6))) % 11

          return S ? (S - 1).toString() : 'k'
        },
      }

      return Validate.validaRut(value)
        ? true
        : createError({ path, message: errorMessage })
    })
  },
)

Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'onlyDigits',
  function (errorMessage) {
    return this.test(`onlyDigits`, errorMessage, function (value) {
      const { path, createError } = this

      if (!value) return createError({ path, message: errorMessage })

      const newValue = value.replace(' ', '')

      const valueValidated = /^[0-9]*$/.test(newValue)

      return valueValidated
        ? true
        : createError({ path, message: errorMessage })
    })
  },
)

const FILE_SIZE = 2 * 1024 * 1024

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf',
]

export const phone = Yup.string()
  .required('Por favor ingrese un número de teléfono')
  .onlyDigits('Solo debes ingresar números')
  .min(8, 'Por favor ingrese un número de teléfono válido')
  .max(8, 'Por favor ingrese un número de teléfono válido')

export const email = Yup.string()
  .required('Ingrese una dirección de correo electrónico')
  .email('Ingresa una dirección de correo electrónico válida')

export const confirmEmail = Yup.string()
  .required('Por favor repite tu correo electrónico')
  .email('Ingresa una dirección de correo electrónico válida')
  .oneOf([Yup.ref('email'), null], 'Los correos deben coincidir')

export const name = Yup.string()
  .required('Seleccione un contacto')
  .min(1, 'Por favor ingrese un nombre válido')

export const firstName = Yup.string()
  .required('Por favor ingrese un nombre')
  .min(2, 'Por favor ingrese un nombre válido')

export const lastName = Yup.string()
  .required('Por favor ingrese un apellido')
  .min(2, 'Por favor ingrese un apellido válido')

export const rut = Yup.string()
  .required('Por favor ingrese un RUT')
  .max(11, 'Por favor ingrese un RUT válido')
  .min(9, 'Por favor ingrese un RUT válido')
  .rutValidation('Por favor ingrese un RUT válido')

export const password = Yup.string()
  .required('Por favor ingrese una contraseña')
  .min(6, 'Longitud mínima de 6 caracteres')

export const confirmPassword = Yup.string()
  .required('Por favor repite tu contraseña')
  .min(6, 'Longitud mínima de 6 caracteres')
  .oneOf([Yup.ref('password'), null], 'Las contraseñas deben coincidir')

export const acceptConditions = Yup.boolean().oneOf(
  [true],
  'Por favor acepta los terminos y condiciones',
)

export const oldPassword = Yup.string().required('Contraseña requerida')

export const newPassword = Yup.string()
  .required('Ingresa tu nueva contraseña')
  .min(6, 'Longitud mínima de 6 caracteres')
  .notOneOf(
    [Yup.ref('oldPassword'), null],
    'No puede ser tu contraseña antigua',
  )

export const confirmNewPassword = Yup.string()
  .required('Repite tu contraseña requerida')
  .min(6, 'Longitud mínima de 6 caracteres')
  .oneOf([Yup.ref('newPassword'), null], 'Las contraseñas deben concidir')
  .notOneOf(
    [Yup.ref('oldPassword'), null],
    'No puede ser tu contraseña antigua',
  )

export const pin = Yup.string()
  .min(4, 'PIN debe tener 4 dígitos')
  .max(4, 'PIN debe tener 4 dígitos')
  .required('PIN obligatorio')

export const newPin = Yup.string()
  .required('Repite tu PIN requerido')
  .min(4, 'PIN debe tener 4 dígitos')
  .max(4, 'PIN debe tener 4 dígitos')
  .notOneOf([Yup.ref('pin'), null], 'No puede ser tu PIN antiguo')

export const confirmNewPin = Yup.string()
  .required('Repite tu PIN requerido')
  .min(4, 'PIN debe tener 4 dígitos')
  .max(4, 'PIN debe tener 4 dígitos')
  .oneOf([Yup.ref('newPin'), null], 'Nuevo PIN no coincide')
  .notOneOf([Yup.ref('pin'), null], 'No puede ser tu PIN antiguo')

export const confirmPin = Yup.string()
  .required('PIN requerido')
  .min(4, 'Longitud mínima de 4 caracteres')
  .oneOf([Yup.ref('pin'), null], 'PIN no coincide con el que ingresaste')

export const vin = Yup.string().required('VIN requerido').min(10, 'Minimo de caracteres')

export const exactlyLengthVin = Yup.string().min(17, 'Minimo de caracteres')

export const shortVin = Yup.string().required('Últimos 8 dígitos de tu VIN requeridos').min(8, 'Mínimo de caracteres')

export const branch = Yup.string().required('Seleccione una sucursal')

export const employee = Yup.string().required('Seleccione un asesor')

export const date = Yup.string().required('Seleccione una fecha')

export const hours = Yup.string().required('Seleccione una hora')

export const address = Yup.string().required('Dirección requerida')

export const radius = Yup.number().required('Radio requerido')

export const geofenceType = Yup.string().required('Tipo de geocerca requerida').min(1)

export const geofenceName = Yup.string().required('Nombre de geocerca requerido').min(1).max(12)

export const radioGroup = Yup.string().required('Opción requerida')

export const street = Yup.string().required('Calle requerida').max(50, 'Máximo de caracteres')

export const streetNumber = Yup.string().required('Numero de calle requerido').max(20, 'Máximo de caracteres')

export const towerApartmentHouse = Yup.string().max(20, 'Máximo de caracteres')

export const commune = Yup.string().required('Comuna requerida').max(50, 'Máximo de caracteres')

export const referenceCode = Yup.string().required('Código requerido')

export const plateNumber = Yup.string()
  .min(6, 'Patente debe tener 6 dígitos')
  .max(6, 'Patente debe tener 6 dígitos')
  .required('Patente obligatoria')

  export const carCode = Yup.string()
  .min(6, 'CarCode debe tener 6 dígitos')
  .max(6, 'CarCode debe tener 6 dígitos')
  .required('CarCode obligatorio')

export const file = Yup
  .mixed()
  .required('Documento requerido')
  .test(
    'fileSize',
    'Documento excede el tamaño máximo',
    value => value && value.size <= FILE_SIZE
  )
  .test(
    'fileFormat',
    'Documento no cumple con el formato',
    value => value && SUPPORTED_FORMATS.includes(value.type)
  )

export const validationCode = Yup.string()
  .min(4, 'Código de validación debe tener 4 dígitos')
  .max(4, 'Código de validación debe tener 4 dígitos')
  .required('Código de validación obligatorio')
